var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Doughnut',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }